import React from 'react'
import {SwitchProps} from './types'
import SwitchView from './SwitchView'

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>((props, _ref): React.ReactElement => <SwitchView {...props} ref={_ref} />)

Switch.displayName = 'Switch'

export default Switch
